(function () {
  'use strict';
  if (!window.IntersectionObserver || !window.ResizeObserver) return;
  var controllers = new Map();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(section) {
    if (controllers.has(section)) return;
    var row = section.querySelector('.logolist--inner');
    var controls = section.querySelector('.pm-poster-scroll-controls');
    var button = controls && controls.querySelector('button');
    if (!row || !button) return;
    var originals = Array.from(row.children);
    var clones = [];
    var period = 0;
    var visible = false;
    var hovered = false;
    var focused = false;
    var interacting = false;
    var userPaused = false;
    var frame = null;
    var resumeTimer = null;
    var lastTime = 0;
    var position = 0;
    var listeners = [];

    function listen(target, name, handler, options) {
      target.addEventListener(name, handler, options);
      listeners.push(function () { target.removeEventListener(name, handler, options); });
    }

    function stop() {
      if (frame !== null) cancelAnimationFrame(frame);
      frame = null;
      lastTime = 0;
      section.dataset.pmPosterState = 'paused';
    }

    function measure() {
      if (clones.length) period = clones[0].offsetLeft - originals[0].offsetLeft;
    }

    function prepare() {
      if (clones.length || reducedMotion.matches || row.scrollWidth <= row.clientWidth + 1) return;
      var fragment = document.createDocumentFragment();
      originals.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.pmPosterClone = '';
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
        clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (node) { node.tabIndex = -1; });
        clone.querySelectorAll('img').forEach(function (img) { img.alt = ''; img.loading = 'lazy'; });
        clones.push(clone);
        fragment.appendChild(clone);
      });
      row.appendChild(fragment);
      measure();
    }

    function canRun() {
      return visible && !document.hidden && !reducedMotion.matches && !hovered && !focused && !interacting && !userPaused && period > 0;
    }

    function tick(now) {
      frame = null;
      if (!canRun()) { stop(); return; }
      if (!lastTime) lastTime = now;
      var elapsed = Math.min(now - lastTime, 64);
      lastTime = now;
      position = (position + elapsed * 0.03) % period;
      row.scrollLeft = position;
      frame = requestAnimationFrame(tick);
    }

    function sync() {
      if (visible && !document.hidden && !reducedMotion.matches) prepare();
      controls.hidden = reducedMotion.matches || period <= 0;
      button.dataset.paused = String(userPaused);
      button.setAttribute('aria-label', userPaused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
      button.title = button.getAttribute('aria-label');
      if (!canRun()) { stop(); return; }
      if (frame !== null) return;
      position = row.scrollLeft % period;
      section.dataset.pmPosterState = 'running';
      frame = requestAnimationFrame(tick);
    }

    function temporaryPause() {
      interacting = true;
      clearTimeout(resumeTimer);
      sync();
      resumeTimer = setTimeout(function () { interacting = false; sync(); }, 2200);
    }

    var intersection = new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      section.dataset.pmPosterVisible = String(visible);
      sync();
    }, { threshold: 0 });
    var resize = new ResizeObserver(function () {
      if (clones.length) measure();
      sync();
    });
    listen(button, 'click', function () { userPaused = !userPaused; sync(); });
    listen(row, 'pointerenter', function (event) { if (event.pointerType === 'mouse') { hovered = true; sync(); } });
    listen(row, 'pointerleave', function () { hovered = false; sync(); });
    listen(row, 'pointerdown', function () { interacting = true; clearTimeout(resumeTimer); sync(); }, { passive: true });
    listen(document, 'pointerup', function () { if (interacting) temporaryPause(); }, { passive: true });
    listen(document, 'pointercancel', function () { if (interacting) temporaryPause(); }, { passive: true });
    listen(row, 'wheel', temporaryPause, { passive: true });
    listen(row, 'focusin', function () { focused = true; sync(); });
    listen(row, 'focusout', function () { queueMicrotask(function () { focused = row.contains(document.activeElement); sync(); }); });
    listen(document, 'visibilitychange', sync);
    listen(reducedMotion, 'change', function () {
      stop();
      if (reducedMotion.matches) {
        if (period > 0) row.scrollLeft %= period;
        clones.forEach(function (clone) { clone.remove(); });
        clones = [];
        period = 0;
      }
      sync();
    });
    intersection.observe(row);
    resize.observe(row);
    section.dataset.pmPosterState = 'paused';
    controllers.set(section, function () {
      stop();
      clearTimeout(resumeTimer);
      intersection.disconnect();
      resize.disconnect();
      listeners.forEach(function (remove) { remove(); });
      clones.forEach(function (clone) { clone.remove(); });
      controllers.delete(section);
    });
  }

  function scan() {
    document.querySelectorAll('[data-pm-poster-autoscroll]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (destroy, section) { if (event.target.contains(section)) destroy(); });
  });
})();
